var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadsideAssistanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.845703,
    y: 25.4863,
    width: 24.7793,
    height: 11.5557,
    rx: 2,
    fill: "url(#paint0_linear_8_42)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68797 41.0563V29.5607C5.68797 29.5362 5.68625 29.5126 5.68283 29.4883C5.31125 26.8479 6.69059 21.5214 15.1779 21.0564C25.8349 20.4724 30.7982 15.9465 30.6522 8.93918C30.5062 1.93184 23.3386 0.898832 21.1488 1.04482C18.959 1.19081 12.5499 1.34844 12.258 9.66966C12.258 14.7792 14.1562 16.385 15.1779 16.969M28.5947 22.3284C31.2753 22.5836 36.6612 24.38 36.7599 29.5239C36.8504 34.239 36.8096 38.5708 36.7705 40.5702C36.7652 40.8416 36.5433 41.0563 36.2719 41.0563H11.3454",
    stroke: "black",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_42",
    x1: 13.2354,
    y1: 25.4863,
    x2: 13.2354,
    y2: 37.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadsideAssistanceIcon);
export default __webpack_public_path__ + "static/media/roadsideAssistanceIcon.7152b795871870884a8964bb6845e5ad.svg";
export { ForwardRef as ReactComponent };